import ActressList from "../views/actressManagement/actressList";
import Main from "../views/main";

const ActressRouter = {
  path: "/actress",
  component: Main,
  title: "女优管理",
  icon: "el-icon-s-promotion",
  meta: {
    keepAlive: true
  },
  children: [{
      path: "/actressList",
      component: ActressList,
      name: "actressList",
      title: "女优列表",
      meta: {
        title: "女优列表",
        keepAlive: true
      },
    },
    
  ],
};
export default ActressRouter;